import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 14,
			fill: "#11C4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 5C16.2091 5 18 6.79086 18 9V12H10V9C10 6.79086 11.7909 5 14 5Z",
			fill: "#11C4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 14C14.8284 14 15.5 14.6716 15.5 15.5C15.5 16.3284 14.8284 17 14 17C13.1716 17 12.5 16.3284 12.5 15.5C12.5 14.6716 13.1716 14 14 14Z",
			fill: "#11C4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 17V19Z",
			fill: "#11C4ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 17C14.8284 17 15.5 16.3284 15.5 15.5C15.5 14.6716 14.8284 14 14 14C13.1716 14 12.5 14.6716 12.5 15.5C12.5 16.3284 13.1716 17 14 17ZM14 17V19M14 5C16.2091 5 18 6.79086 18 9V12H10V9C10 6.79086 11.7909 5 14 5Z",
			stroke: "white",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12H20V18C20 20.2091 18.2091 22 16 22H12C9.79086 22 8 20.2091 8 18V12Z",
			stroke: "white"
		})
	]
});
export default SvgLockBadge;
